//  Note this is deprecated import directly from corresponded file
// TODO remove this usage from code
export { categoriesGql, getCategoryDetails } from "./categories.gql";
export { subCategoriesNameListByCategoryId } from "./subCategoriesNameListByCategoryName.gql";
export {
  globalStoresByCatName,
  getStoreBySlug,
  getAffariyets,
  getStoreReview,
  globalSearch,
  getPopularAffariyetBySubCategory,
} from "./stores.gql";
